import { EntityActionType, EntityOptions } from './types';

export const requestInFlight = ({ type, ...options } = {} as EntityOptions) => ({
  type: EntityActionType.REQUEST_IN_FLIGHT,
  ...(type && { requestActionType: type }),
  ...options
});

export const requestSuccess = (data, { type, ...options } = {} as EntityOptions) => ({
  type: EntityActionType.REQUEST_SUCCESS,
  data,
  ...(type && { requestActionType: type }),
  ...options
});

export const requestError = (err, { type, ...options } = {} as EntityOptions) => ({
  type: EntityActionType.REQUEST_ERROR,
  data: Array.isArray(err) ? err : [err],
  ...(type && { requestActionType: type }),
  ...options
});

export const cancelDownload = () => ({
  type: EntityActionType.CANCEL_DOWNLOAD_REQUEST
});

export const cancelLoading = () => ({
  type: EntityActionType.CANCEL_LOADING
});

export const resetValue = (key: string) => ({
  type: EntityActionType.RESET_KEY,
  key
});

export const updateEntity = (data, { type, ...options } = {} as EntityOptions) => {
  return {
    type: EntityActionType.REQUEST_SUCCESS,
    data,
    ...(type && { requestActionType: type }),
    ...options
  };
};
